var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinionRun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 249,
    viewBox: "0 0 182 249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_380_2721",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 0,
    width: 152,
    height: 206
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179.343 66.5193C188.222 24.1683 128.986 -27.1459 49.4737 16.8368L32.6878 73.0351C30.4549 87.9957 27.4921 99.2948 32.6878 101.541C32.6878 101.541 43.2896 104.799 45.0567 106.427C46.8238 108.054 38.8719 113.76 37.9886 114.573C37.1054 115.386 32.6878 117.831 32.6878 117.831C25.6205 121.902 43.0265 207.014 43.2894 205.793H167.858C167.858 205.793 169.625 118.642 171.392 107.241C173.159 95.8402 170.465 108.87 179.343 66.5193Z",
    fill: "#FDDB44"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_380_2721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.343 66.5193C188.222 24.1683 128.986 -27.1459 49.4737 16.8368L32.6878 73.0351C30.4549 87.9957 27.4921 99.2948 32.6878 101.541C32.6878 101.541 43.2896 104.799 45.0567 106.427C46.8238 108.054 38.8719 113.76 37.9886 114.573C37.1054 115.386 32.6878 117.831 32.6878 117.831C25.6205 121.902 43.0265 207.014 43.2894 205.793H167.858C167.858 205.793 169.625 118.642 171.392 107.241C173.159 95.8402 170.465 108.87 179.343 66.5193Z",
    fill: "#FDDB44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.609 63.9914C120.009 30.9313 106.895 17.6451 71 -1.51354C112.043 -7.51401 180.913 3.48683 183 52.9906V105.995L167.696 141.497L163.522 179H90.4783C109.041 130.557 114.978 105.331 117.609 63.9914Z",
    fill: "#FCB537"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9395 137.377C87.5878 107.271 112.484 112.485 158.14 139.821L174.042 143.893C178.69 177.816 173.159 196.834 168.741 204.164C164.324 211.493 139.286 221.109 119.267 219.638H84.8115C84.6874 219.622 52.9882 215.549 43.2891 207.421C33.571 199.277 27.3867 148.78 27.3867 148.78L29.1533 147.965V137.377C35.9215 138.545 39.6364 138.547 45.9395 137.377ZM149.306 145.521C110.446 123.58 89.2287 121.289 53.0078 143.078L57.4248 174.841H147.538L149.306 145.521Z",
    fill: "#27456A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2518 14.3921L2.65019 60.0023C2.65019 60.0023 0.883279 52.6721 3.53366 36.3827C6.18403 20.0934 13.2518 14.3921 13.2518 14.3921Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85779 67.3226L29.7753 73.7249C31.8858 74.2462 34.0262 72.9866 34.5952 70.8885L49.2932 16.688C49.8781 14.5309 48.5821 12.313 46.4156 11.7637L18.9458 4.79951C16.7852 4.25174 14.5936 5.57574 14.0733 7.74317L0.92755 62.5057C0.414293 64.6438 1.7231 66.7953 3.85779 67.3226Z",
    fill: "#524E46"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0754 35.8131L36.8449 46.5345C36.5091 47.6489 37.2101 48.8176 38.3469 49.0676C92.7647 61.0336 123.278 66.0202 177.389 72.0037C178.467 72.1229 179.46 71.3619 179.606 70.2869L180.833 61.2394C180.985 60.118 180.157 59.092 179.031 58.9778C120.214 53.0106 89.2392 47.3627 42.5384 34.4651C41.49 34.1755 40.3892 34.7717 40.0754 35.8131Z",
    fill: "#383531"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118.405 172.912C114.662 162.759 112.345 155.698 107.853 141.069C117.912 141.309 122.211 143.989 126.943 152.647C134.594 168.898 134.99 176.423 130.396 187.686C114.589 186.056 106.548 183.237 92.6752 177.097L94.6597 165.56C103.36 169.815 108.386 171.851 118.405 172.912Z",
    fill: "#FDDB44"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2919 164.058C95.9493 170.685 95.1416 173.524 93.1729 178.19L82.2726 174.481C82.2726 174.481 77.5301 177.986 74.6761 176.584C72.2584 175.396 70.7342 173.178 71.3722 170.773C72.1154 167.972 78.4674 168.811 79.6078 168.985C78.5256 168.803 72.7634 167.704 71.9574 164.833C71.2488 162.308 72.1267 159.99 74.4871 158.828C76.4568 157.859 79.425 159.712 81.1808 161.052C79.5375 159.559 77.1856 156.974 78.0127 155.011C79.2476 152.08 83.7475 151.109 86.4233 153.251C88.8165 155.167 87.1502 160.628 87.1502 160.628L95.2919 164.058Z",
    fill: "#27241E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M146.656 226.968L147.539 214.751L139.588 218.009L126.336 219.638L134.287 231.04L146.656 226.968Z",
    fill: "#10293B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8949 230.297L82.1278 216.332L55.3212 209.045L59.0457 227.833L74.8949 230.297Z",
    fill: "#27456A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5234 223.71L59.1927 227.783L75.0951 230.226L71.5613 240.814L38.873 233.484L41.5234 223.71Z",
    fill: "#27241E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M122.18 233.752L136.244 229.159L148.109 224.046L152.693 234.103L126.807 242.764L122.18 233.752Z",
    fill: "#27241E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinionRun);
export default __webpack_public_path__ + "static/media/minion-run.b1d68b2bb7de6d096e478498351a1521.svg";
export { ForwardRef as ReactComponent };